import './App.css';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { routeChanged } from './utils/pageTiming';
import ScanListener from './components/ScanListener';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import FloorPlanDashboardPage from './pages/FloorPlanDashboardPage';
import FloorPlanEditorPage from './pages/FloorPlanEditorPage';
import HardwarePage from './pages/HardwarePage';
import FailedPrintsPage from './pages/FailedPrintsPage';
import NotFoundPage from './pages/NotFoundPage';
import Takeaway from './pages/Takeaway';
import ProductManagementPage from './pages/ProductManagementPage';
import Customer from './pages/Customer';
import CustomerProfilePage from './pages/CustomerProfilePage';
import Orders from './pages/Orders';
import OrderReview from './pages/OrderReview';
import PaymentView from './pages/PaymentView';
import SelectCustomer from './pages/SelectCustomer';
import DeliveryAddress from './pages/DeliveryAddress';
import UberEatsOrders from './pages/UberEatsOrders';
import OrderTransfer from './pages/OrderTransfer';
import OrderTransferTable from './pages/OrderTransferTable';
import OrderTransferOrder from './pages/OrderTransferOrder';
import Reservations from './pages/Reservations';
import Revenue from './pages/Revenue';
import ClockinClockout from './pages/ClockinClockout';
import TeamTimesheets from './pages/TeamTimesheets';
import FinalizeOrder from './pages/FinalizeOrder';
import PendingOrders from './pages/PendingOrders';
import Promotions from './pages/Promotions';
import SupportPage from './pages/SupportPage';
import SettingsPage from './pages/SettingsPage';
import OperatingHoursPage from './pages/OperatingHoursPage';
import OfflineModePage from './pages/OfflineModePage';
import GlobalLoader from './components/GlobalLoader';

// Reads the per-restaurant layout preference (set at login, changeable from the Header dropdown)
// and picks which "home screen" /dashboard renders — the traditional category grid, or the
// visual floor-plan view. Listens for the Header's toggle so switching applies immediately,
// with no reload/re-login needed.
// Tells the page timer (Settings > Performance) when the screen changes.
function PageTimingTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    routeChanged(pathname);
  }, [pathname]);
  return null;
}

function DashboardRouter() {
  const [layoutMode, setLayoutMode] = useState(localStorage.getItem('layout_mode') || 'grid');

  useEffect(() => {
    const onLayoutModeChanged = () => {
      setLayoutMode(localStorage.getItem('layout_mode') || 'grid');
    };
    window.addEventListener('layoutModeChanged', onLayoutModeChanged);
    return () => window.removeEventListener('layoutModeChanged', onLayoutModeChanged);
  }, []);

  return layoutMode === 'floor_plan' ? <FloorPlanDashboardPage /> : <DashboardPage />;
}

function App() {
  return (
    <Router>
        <GlobalLoader />
        <PageTimingTracker />
        <ScanListener />
      <div className="App">
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/dashboard" element={<DashboardRouter />} />
          <Route path="/floor-plan" element={<FloorPlanEditorPage />} />
          <Route path="/hardware" element={<HardwarePage />} />
          <Route path="/failed-prints" element={<FailedPrintsPage />} />
          <Route path="/takeaway" element={<Takeaway />} />
          <Route path="/product-management" element={<ProductManagementPage />} />
          <Route path="/customer" element={<Customer />} />
          <Route path="/customer/:id" element={<CustomerProfilePage />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/order-review" element={<OrderReview />} />
          <Route path="/payment-view" element={<PaymentView />} />
          <Route path="/select-customer" element={<SelectCustomer />} />
          <Route path="/add-delivery-address" element={<DeliveryAddress />} />
          <Route path="/ubereats/orders" element={<UberEatsOrders />} />
          <Route path="/order-transfer" element={<OrderTransfer />} />
          <Route path="/order-transfer-table" element={<OrderTransferTable />} />
          <Route path="/order-transfer-order" element={<OrderTransferOrder />} />
          <Route path="/reservations" element={<Reservations />} />
          <Route path="/Revenue" element={<Revenue />} />
          <Route path="/clockin-clockout" element={<ClockinClockout />} />
          <Route path="/team-timesheets" element={<TeamTimesheets />} />
          <Route path="/finalize-order" element={<FinalizeOrder />} />
          <Route path="/pending-orders" element={<PendingOrders />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/operating-hours" element={<OperatingHoursPage />} />
          <Route path="/offline" element={<OfflineModePage />} />

          
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;